import ScoreAnalysis from "./ScoreAnalysis";
import LetteredTextInputs from "./LetteredTextInputs";
import QuestionLayout from "./QuestionLayout";
import { useState } from "react";

function normalizePitchNameInput(input) {
  if (!input) return "";

  const s = input
    .trim()
    .replace(/♭/g, "b")
    .replace(/♯/g, "#")
    .replace(/♮/g, "");

  const m = s.match(/^([A-Ga-g])([#b]{0,2})$/);
  if (!m) return s;

  return m[1].toUpperCase() + m[2];
}

function insertAccidental(value, accGlyph) {
  return value + accGlyph;
  const normalized = normalizePitchNameInput(value || "");
  const m = normalized.match(/^([A-G])([#b]{0,2})$/);

  if (!m) return normalizePitchNameInput(accGlyph);
  return normalizePitchNameInput(m[1] + accGlyph);
}

function AccidentalButtons({ onSelect }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {[
        { label: "♭", value: "♭" },
        { label: "♯", value: "♯" }
      ].map(({ label, value }) => (
        <button
          key={value}
          tabIndex={-1}
          style={{
            fontSize: 16,
            padding: "2px 6px",
            cursor: "pointer"
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(value);
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default function TextInputWidget({
  config,
  value = "",
  onChange,
  mode = "edit",
  feedback
}) {
  const [focused, setFocused] = useState(false);

  if (config.variant === "score-analysis") return <ScoreAnalysis config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>;
  if (Array.isArray(config.rows)) return <LetteredTextInputs config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>;

  // Cadence answers are words, including exams saved with keyNameLoose.
  const isCadence = config.normalization === "cadence" || /^cadence$/i.test(String(config.suffix || "").trim());
  const showAccidentals = config.allowTypedAccidentalButtons ?? !isCadence;

  const part =
    Array.isArray(feedback?.parts) && feedback.parts.length > 0
      ? feedback.parts[0]
      : null;

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center"
          }}
        >
          <input
            type="text"
            value={value}
            disabled={mode !== "edit"}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={(e) =>
              onChange(isCadence ? e.target.value : normalizePitchNameInput(e.target.value))
            }
            style={{
              fontSize: 16,
              textAlign: "center",
              padding: "8px 10px",
              borderRadius: 6,
              border:
                mode === "review"
                  ? part?.correct
                    ? "2px solid #2e7d32"
                    : "2px solid #c62828"
                  : "1px solid #aaa",
              width: isCadence ? 140 : 50
            }}
          />

          {showAccidentals && focused && mode === "edit" && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                marginTop: 4,
                zIndex: 10
              }}
            >
              <AccidentalButtons
                onSelect={(acc) =>
                  onChange(insertAccidental(value, acc))
                }
              />
            </div>
          )}
        </div>

        {config.suffix && (
          <span
            style={{
              fontSize: 16,
              color: "#000",
              fontWeight: "bold",
              whiteSpace: "nowrap"
            }}
          >
            {config.suffix}
          </span>
        )}
      </div>
    </QuestionLayout>
  );
}
